module.exports = __webpack_public_path__ + "media/Video 154b.ee8b86de.mp4";